import { Observable, Subscriber } from 'rxjs'

export const resizeObservable = (elem: HTMLElement): Observable<ResizeObserverEntry[]> =>
    new Observable((subscriber: Subscriber<ResizeObserverEntry[]>) => {
        const resizeObserver: ResizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) =>
            subscriber.next(entries)
        )

        // Observe one or multiple elements
        resizeObserver.observe(elem)

        return (): void => resizeObserver.unobserve(elem)
    })

export const mutationObservable = (elem: HTMLElement, options?: MutationObserverInit): Observable<MutationRecord[]> =>
    new Observable((subscriber: Subscriber<MutationRecord[]>) => {
        const observer: MutationObserver = new MutationObserver((mutations: MutationRecord[]) =>
            subscriber.next(mutations)
        )

        observer.observe(
            elem,
            options ?? {
                childList: true,
                subtree: true
            }
        )

        return (): void => observer.disconnect()
    })

export const intersectionObservable = (
    elem: HTMLElement,
    options?: IntersectionObserverInit
): Observable<IntersectionObserverEntry[]> =>
    new Observable((subscriber: Subscriber<IntersectionObserverEntry[]>) => {
        const observer: IntersectionObserver = new IntersectionObserver(
            (entries: IntersectionObserverEntry[]) => subscriber.next(entries),
            options ?? {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }
        )

        observer.observe(elem)

        return (): void => observer.disconnect()
    })
